import * as React from "react";
import { forwardRef, memo } from "react";
const SvgReply = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 11L1 6M1 6L6 1M1 6H7.4C10.7603 6 12.4405 6 13.7239 6.65396C14.8529 7.2292 15.7708 8.14708 16.346 9.27606C17 10.5595 17 12.2397 17 15.6V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgReply);
const Memo = memo(ForwardRef);
export default Memo;
